import React from "react";

const Help = props => (
  <svg viewBox="0 0 21 21" fill="none" {...props}>
    <path
      d="M10.333.5c5.508 0 10 4.492 10 10 0 5.547-4.492 10-10 10a9.97 9.97 0 01-10-10c0-5.508 4.453-10 10-10zm0 18.125c4.454 0 8.125-3.633 8.125-8.125 0-4.453-3.671-8.125-8.125-8.125-4.492 0-8.125 3.672-8.125 8.125a8.119 8.119 0 008.125 8.125zm0-5c.664 0 1.25.547 1.25 1.25s-.586 1.25-1.25 1.25c-.742 0-1.25-.547-1.25-1.25s.547-1.25 1.25-1.25zm1.29-8.125c1.562 0 2.773 1.21 2.734 2.734 0 .938-.508 1.836-1.328 2.344l-1.758 1.094v.078a.95.95 0 01-.938.938.95.95 0 01-.937-.938v-.625c0-.313.156-.625.469-.82l2.226-1.328a.837.837 0 00.43-.743c0-.468-.43-.859-.938-.859H9.591c-.469 0-.82.39-.82.86a.95.95 0 01-.938.937.95.95 0 01-.937-.938A2.718 2.718 0 019.63 5.5h1.992z"
      fill="currentColor"
    />
  </svg>
);

export default Help;
